import { create } from 'zustand';
import api from '../services/api'; // Adjusted path if needed

interface ThemeState {
  theme: { primary: string; logo: string };
  loadTheme: () => Promise<void>;
}

export const useTheme = create<ThemeState>((set) => ({
  theme: { primary: '#2563eb', logo: 'default.png' }, // Defaults
  loadTheme: async () => {
    try {
      const res = await api.get('/api/themes'); // Stub endpoint; replace with real
      set({ theme: res.data });
    } catch (err) {
      console.error('Theme load failed:', err);
    }
  },
}));